import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePageContext } from 'pageContext'
import { Card } from 'packages/eid-ui'
import { Box, FormControlLabel, Radio, Skeleton, styled } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import { useApprovalFlowDecisions } from 'hooks'

const StyledFormControlLabel = styled(FormControlLabel)({
    padding: '6px',
    '& .MuiFormControlLabel-label': {
        fontSize: '14px',
        color: '#000000',
    },
})

const StyledRadioControl = styled(Radio)({
    padding: '0px 12px 0px 0px',
})

const StyledRadio = (props) => {
    const { checked, label, onChange, value } = props
    return (
        <StyledFormControlLabel
            checked={checked}
            value={value}
            label={label}
            labelPlacement="end"
            control={
                <StyledRadioControl
                    icon={<Icon name="Radio" />}
                    checkedIcon={<Icon name="RadioFilled" />}
                />
            }
            onChange={onChange}
        />
    )
}

const RadioFilter = () => {
    const { t } = useTranslation()
    const [state, dispatch] = usePageContext()
    const { data, isLoading } = useApprovalFlowDecisions()

    const onHandleChange = (e) => {
        const value = e.target.value
        dispatch({
            type: 'SET_PROP',
            payload: {
                key: 'approvalDecision',
                value: value,
            },
        })
    }

    return (
        <>
            {isLoading ? (
                <Box paddingTop={'16px'} marginX={'24px'}>
                    <Skeleton height={40} />
                </Box>
            ) : (
                <Box paddingTop={'16px'}>
                    {data.map((d) => (
                        <Box key={d.id + d.name} marginX={'24px'}>
                            <StyledRadio
                                label={t(`${d.name}`)}
                                checked={state.approvalDecision === d.name}
                                value={d.name}
                                onChange={onHandleChange}
                            />
                        </Box>
                    ))}
                </Box>
            )}
        </>
    )
}

const ApprovalDecisionFilter = () => {
    const { t } = useTranslation()
    const [state] = usePageContext()

    return (
        <Card
            cardTitle={t('ApprovalDecision')}
            collapsible
            expanded={Boolean(state.approvalDecision)}
        >
            <RadioFilter />
        </Card>
    )
}

export default ApprovalDecisionFilter
